import { toPosAmount } from '@/components/pos/posCatalog'

/** @typedef {import('@/types/api').PosQuickKey} PosQuickKey */
/** @typedef {import('@/components/pos/posCatalog').PosGender} PosGender */

/**
 * @param {PosQuickKey} key
 * @param {PosGender} gender
 */
export function resolveQuickKeyPrice(key, gender) {
  if (key.item_type === 'product') {
    return toPosAmount(key.sell_price ?? key.product?.sell_price)
  }

  const ladies = toPosAmount(key.price_ladies ?? key.service?.price_ladies)
  const gents = toPosAmount(key.price_gents ?? key.service?.price_gents)
  return gender === 'gents' ? gents : ladies
}

/**
 * @param {PosQuickKey} key
 */
export function getQuickKeyDuration(key) {
  if (key.item_type === 'product') return 0
  return key.duration ?? key.service?.duration ?? 0
}

/**
 * @param {PosQuickKey} key
 */
export function getQuickKeyLabel(key) {
  return key.display_name ?? key.label ?? key.service?.name ?? key.product?.name ?? 'Quick key'
}
